__turbopack_context__.v({
  "className": "roboto_ff8708c0-module__QpeZxW__className",
});
